/**
 * Optimaxx Summary — Compact footer with min investment, suggested monthly,
 * ideal-for and CTA. Consolidates the leftover info from the old product card.
 */
import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import './OptimaxxSummary.css';

const OptimaxxSummary = ({ product, onCtaClick }) => (
  <div className="optimaxx-summary" data-testid="optimaxx-summary">
    <div className="optimaxx-summary-grid">
      <div className="optimaxx-summary-card">
        <span className="summary-card-label">Inversión mínima</span>
        <span className="summary-card-value">${product.minAmount.toLocaleString()}</span>
      </div>
      <div className="optimaxx-summary-card">
        <span className="summary-card-label">Aporte mensual sugerido</span>
        <span className="summary-card-value summary-highlight">${product.recommendedMonthly.toLocaleString()}</span>
      </div>
      <div className="optimaxx-summary-card optimaxx-summary-wide">
        <span className="summary-card-label">Ideal para</span>
        <span className="summary-card-text">{product.idealFor}</span>
      </div>
    </div>

    <Button
      size="lg"
      className="button-neon optimaxx-summary-cta"
      onClick={onCtaClick}
      data-testid="optimaxx-summary-cta"
    >
      <ArrowRight className="w-5 h-5 mr-2" />
      Quiero conocer más sobre Optimaxx Plus
    </Button>
  </div>
);

export default OptimaxxSummary;
